import { useMemberMutations } from "@app/entities/member/mutations";
import axios from "axios";
import { useEffect } from "react";

const isLive = process.env.NODE_ENV === "production";

const axiosInstance = axios.create({
  baseURL: isLive ? `/api` : `http://localhost:8335/api`,
  withCredentials: true,
  headers: {
    post: {
      ...axios.defaults.headers.post,
      "Content-Type": "application/json",
    },
  },
});

axiosInstance.interceptors.request.use((config) => {
  if (config.data instanceof FormData) {
    delete config.headers["Content-Type"];
  }
  return config;
});

export const setupAxiosInterceptors = (logout: () => void) => {
  axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error?.response?.status === 401 || error?.response?.status === 403) {
        logout();
        
      }
      return Promise.reject(error); // Ensure the error is thrown to be handled by React Query
    },
  );
};

export const useAxiosInterceptor = () => {
  const { logout } = useMemberMutations();

  useEffect(() => {
    setupAxiosInterceptors(logout);
  }, [logout]);
};

export default axiosInstance;
